/**
 * SectionHeader — Powersure brand-mark + label + titel.
 * Eén consistente kop voor elke premium sectie.
 */
import { Zap } from 'lucide-react';
import { psCls } from '@/lib/powersure-theme';

export default function SectionHeader({
  label,
  title,
  subtitle,
  Icon = Zap,
  align = 'left',
  className = '',
}) {
  const alignCls = align === 'center' ? 'text-center items-center' : 'text-left';
  return (
    <div className={`flex flex-col ${alignCls} ${className}`}>
      {label && (
        <div className={`flex items-center gap-2 mb-3 ${align === 'center' ? 'justify-center' : ''}`}>
          <span className={psCls.iconBadge}>
            <Icon className="w-4 h-4" />
          </span>
          <span className={psCls.label}>{label}</span>
        </div>
      )}
      {title && (
        <h2 className={psCls.h2} style={{ fontFamily: 'Outfit' }}>{title}</h2>
      )}
      {subtitle && (
        <p className={`${psCls.body} mt-2 max-w-2xl`}>{subtitle}</p>
      )}
    </div>
  );
}
